var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { injectIntl } from "@irati/utils/lang";
import ArchiveCompanyValueMutation from "@irati/companyvalues/apollo/mutation/Archive";
import authentication from "@irati/auth";
import { companyValuesTracking } from "@irati-tracking/admin";
import { AreYouSurePopUp } from "../../AreYouSurePopUp/index";
var CompanyValueArchive = /** @class */ (function (_super) {
    __extends(CompanyValueArchive, _super);
    function CompanyValueArchive() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.submit = function (onSubmit) {
            companyValuesTracking.archiveCompanyValue();
            onSubmit();
        };
        return _this;
    }
    CompanyValueArchive.prototype.render = function () {
        var _this = this;
        var _a = this.props, closeArchiveModal = _a.closeArchiveModal, companyValue = _a.companyValue, formatMessage = _a.formatMessage;
        var tenantId = authentication.userTenant().uuid;
        var load = false;
        return (React.createElement(ArchiveCompanyValueMutation, { companyValue: companyValue, onCompleted: closeArchiveModal, tenantId: tenantId }, function (onSubmit) { return (React.createElement(AreYouSurePopUp, { buttonText: formatMessage({ id: "admin.companyValues.archive.button" }), load: load, onCancel: closeArchiveModal, onSubmit: function () { return _this.submit(onSubmit); }, open: true, text: formatMessage({ id: "admin.companyValues.archive.body" }) })); }));
    };
    return CompanyValueArchive;
}(Component));
export default injectIntl(CompanyValueArchive);
